(() => {
  const script = document.querySelector('script[data-sturm-language-default]');
  if (!script || window.Shopify?.designMode) return;
  const currentLanguage = script.dataset.language;
  const available = script.dataset.languages.split(',');
  const preferenceKey = 'sturm_explicit_language_v1';
  const sessionKey = 'sturm_country_language_checked_v1';
  let manualSelection = false;
  const rememberSelection = (language) => {
    if (!available.includes(language)) return;
    manualSelection = true;
    try {
      localStorage.setItem(preferenceKey, language);
      sessionStorage.setItem(sessionKey, '1');
    } catch (_) {}
  };
  document.addEventListener('click', (event) => {
    const option = event.target.closest?.('localization-form a[data-value]');
    if (!option) return;
    const form = option.closest('form');
    if (form?.querySelector('input[name="locale_code"],input[name="language_code"]')) {
      rememberSelection(option.dataset.value);
    }
  }, true);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches?.('form[action*="/localization"]')) return;
    const input = form.querySelector('input[name="locale_code"],input[name="language_code"]');
    if (input) rememberSelection(input.value);
  }, true);
  const switchLanguage = (language) => {
    if (manualSelection || !available.includes(language) || language === currentLanguage) return;
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.hidden = true;
    const fields = {
      _method: 'PUT',
      form_type: 'localization',
      language_code: language,
      return_to: window.location.pathname + window.location.search + window.location.hash
    };
    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  };
  const start = async () => {
    let preference;
    try {
      preference = localStorage.getItem(preferenceKey);
      if (available.includes(preference)) {
        switchLanguage(preference);
        return;
      }
      if (sessionStorage.getItem(sessionKey)) return;
      sessionStorage.setItem(sessionKey, '1');
    } catch (_) { return; }
    try {
      const response = await fetch(script.dataset.root + 'browsing_context_suggestions.json?country[enabled]=true', {
        credentials: 'same-origin',
        signal: AbortSignal.timeout(4000)
      });
      if (!response.ok) throw new Error('Localization lookup failed');
      const data = await response.json();
      const country = data.detected_values?.country?.handle;
      if (!country) {
        sessionStorage.removeItem(sessionKey);
        return;
      }
      switchLanguage(['DE', 'AT', 'CH'].includes(country.toUpperCase()) ? 'de' : 'en');
    } catch (_) {
      try { sessionStorage.removeItem(sessionKey); } catch (_) {}
    }
  };
  start();
})();
